import { getUid as olGetUid } from "ol/util";
export default function getUid(feature) {
    return olGetUid(feature).toString();
}
